import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { BackToMyPageButton } from "../../molecules/BackToMyPageButton";
import { DeactivateForm } from "../../organisms/form/DeactivateForm";
import { useDeactivate } from "./hook";

export const Deactivate: React.FC = () => {
  const { handleDeactivate } = useDeactivate();

  return (
    <Container>
      <TitleWrapper>退会</TitleWrapper>
      <Message>
        下の入力欄にご登録メールアドレスとパスワードを入力していただき、「退会する」ボタンをクリックしてください。
      </Message>
      <Message>※印は必須項目です。</Message>

      <DeactivateForm handleSubmit={handleDeactivate} />

      <ButtonWrapper>
        <BackToMyPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px;
  margin: 0 auto 80px;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  padding: 43px 0 38px;
  font-weight: 500;
  display: flex;
  line-height: 1;
  justify-content: center;
  font-family: "Hiragino Sans";
`;

const Message = styled.p`
  font-size: 14px;
  color: ${BASIC_DARK_GRAY};
  font-weight: 200;
  margin-bottom: 20px;
  text-align: left;
  font-family: "Hiragino Sans";
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  button {
    font-family: "Hiragino Sans";
    line-height: 1;
    height: auto;
    font-weight: 500;
  }
`;
